import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as CloseIcon } from "./../../../images/editor-icons/log-out.svg";
import ActionList from "../../../shared/components/ActionList";
import { StyledNavigationMobile } from "../../Navigation/NavigationMobileStyles";
import Action from "../../../shared/components/Action";
import { useHistory } from "react-router-dom";

const CloseEditorButton: React.FC = () => {
  const history = useHistory(); 
  
  return (
    <StyledNavigationMobile>
      <ActionList>
         <Action
          icon={<CloseIcon />}
          onClick={() => {
            history.push("/");
          }}
          >
          <FormattedMessage
            id="editor.exit_button"
            defaultMessage="Exit editor"
            description="Text editor exit button"
          />
          </Action>
      </ActionList>
    </StyledNavigationMobile>
  );
};

export default CloseEditorButton;
